import { defineStore } from "pinia";
import { ref } from "vue";

const SENTINEL_VERSIONS = new Set(['', 'local-dev', 'unknown']);

export const useGlobalStore = defineStore("storeGlobal", () =>
{



  // Build info
  const buildVersion = ref('');
  const buildDate = ref('');
  const hasNewVersion = ref(false);

  // Debug
  const showDebug = ref(localStorage.getItem('debug') === 'true');
  const showAuthDebug = ref(localStorage.getItem('authDebug') === 'true');

  // Menu edit
  const editMenu = ref(false);

  // Setter for build info (kalles fra auth.ts)
  function setBuildInfo (version, date) {
    buildVersion.value = version || '';
    buildDate.value = date || '';
  }

  // Sammenligner versjon fra server (X-Build-Version-header eller /api/config.buildVersion)
  // mot startup-versjonen. Flagger hasNewVersion ved mismatch; aldri nullstilles.
  function markVersionSeen (serverVersion) {
    if (hasNewVersion.value) return;
    const local = buildVersion.value;
    if (SENTINEL_VERSIONS.has(local)) return;
    const server = String(serverVersion ?? '').trim();
    if (SENTINEL_VERSIONS.has(server)) return;
    if (server !== local) {
      hasNewVersion.value = true;
    }
  }

  // Eksplisitte actions for å sette debug-flagg
  function setDebug (enabled) {
    showDebug.value = enabled;
    localStorage.setItem('debug', enabled.toString());
  }

  function setAuthDebug (enabled) {
    showAuthDebug.value = enabled;
    localStorage.setItem('authDebug', enabled.toString());
  }

  // Logging helper
  function debug (...args)
  {
    if (showDebug.value) {
      console.debug(...args);
    }
  }

  function authDebug (...args)
  {
    if (showAuthDebug.value) {
      console.debug('[Auth]', ...args);
    }
  }

  return {
    buildVersion,
    buildDate,
    hasNewVersion,
    setBuildInfo,
    markVersionSeen,
    showDebug,
    showAuthDebug,
    editMenu,
    setDebug,
    setAuthDebug,
    debug,
    authDebug,
  };
});
